module.exports = __webpack_public_path__ + "img/tip.069fa92d.svg";